/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  IsTraceabilityRequestsSortableByOrderDateQueryResponse,
  IsTraceabilityRequestsSortableByOrderDateQueryParams,
} from "../types/IsTraceabilityRequestsSortableByOrderDate.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const isTraceabilityRequestsSortableByOrderDateQueryKey = (
  params?: IsTraceabilityRequestsSortableByOrderDateQueryParams
) =>
  [
    { url: "/v1/traceability-requests/sorts/order-date" },
    ...(params ? [params] : []),
  ] as const

export type IsTraceabilityRequestsSortableByOrderDateQueryKey = ReturnType<
  typeof isTraceabilityRequestsSortableByOrderDateQueryKey
>

/**
 * @summary Check if traceability requests are sortable by order date
 * {@link /v1/traceability-requests/sorts/order-date}
 */
export async function isTraceabilityRequestsSortableByOrderDate(
  params?: IsTraceabilityRequestsSortableByOrderDateQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    IsTraceabilityRequestsSortableByOrderDateQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-requests/sorts/order-date`,
    params,
    ...requestConfig,
  })
  return res
}

export function isTraceabilityRequestsSortableByOrderDateQueryOptions(
  params?: IsTraceabilityRequestsSortableByOrderDateQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = isTraceabilityRequestsSortableByOrderDateQueryKey(params)
  return queryOptions<
    ResponseConfig<IsTraceabilityRequestsSortableByOrderDateQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<IsTraceabilityRequestsSortableByOrderDateQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return isTraceabilityRequestsSortableByOrderDate(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Check if traceability requests are sortable by order date
 * {@link /v1/traceability-requests/sorts/order-date}
 */
export function useIsTraceabilityRequestsSortableByOrderDate<
  TData =
    ResponseConfig<IsTraceabilityRequestsSortableByOrderDateQueryResponse>,
  TQueryData =
    ResponseConfig<IsTraceabilityRequestsSortableByOrderDateQueryResponse>,
  TQueryKey extends QueryKey =
    IsTraceabilityRequestsSortableByOrderDateQueryKey,
>(
  params?: IsTraceabilityRequestsSortableByOrderDateQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<IsTraceabilityRequestsSortableByOrderDateQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    isTraceabilityRequestsSortableByOrderDateQueryKey(params)

  const query = useQuery(
    {
      ...isTraceabilityRequestsSortableByOrderDateQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
